import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  onAddCategory: (name: string) => Promise<void>;
}

const AddCategoryModal: React.FC<AddCategoryModalProps> = ({ open, onClose, onAddCategory }) => {
  const [newCategoryName, setNewCategoryName] = useState('');
  const [categoryError, setCategoryError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    if (!newCategoryName.trim()) {
      setCategoryError('Category name cannot be empty.');
      return;
    }
    setLoading(true);
    setCategoryError('');
    try {
      await onAddCategory(newCategoryName);
      setNewCategoryName('');
      onClose();
    } catch (err) {
      setCategoryError('Failed to add category.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setNewCategoryName('');
    setCategoryError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add New Category</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Category Name"
          type="text"
          fullWidth
          value={newCategoryName}
          onChange={e => setNewCategoryName(e.target.value)}
          error={!!categoryError}
          helperText={categoryError}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" disabled={loading}>Cancel</Button>
        <Button onClick={handleSave} color="primary" variant="contained" disabled={loading}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCategoryModal;
